import { render, staticRenderFns } from "./CavGif.vue?vue&type=template&id=612ab125&"
import script from "./CavGif.vue?vue&type=script&lang=js&"
export * from "./CavGif.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports